module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CreateLegalCase"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Create New Case",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region_id),
      expression: "region_id"
    }],
    staticClass: "form-control col-sm-9",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.region_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateDistricts()
      }]
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.district_id),
      expression: "district_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.district_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateAllocatedGroup()
      }]
    }
  }, _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                              " + _vm._s(option.district_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Allocate to")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigned_to_id),
      expression: "assigned_to_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assigned_to_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allocatedGroup), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Title")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legalCaseTitle),
      expression: "legalCaseTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.legalCaseTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.legalCaseTitle = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Case priority")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case_priority_id),
      expression: "legal_case_priority_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.legal_case_priority_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.legalCasePriorities), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.case_priority) + "\n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legalCaseDetails),
      expression: "legalCaseDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.legalCaseDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.legalCaseDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-336c433c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/create_legal_case_modal.vue
// module id = 952
// module chunks = 0